import {
  Types,
  ILoyaltyState,
  ILoyaltyRewardsResponse,
  ILoyaltyGoalResponse,
  ILoyaltyHistoryResponse,
  ILoyaltyProductResponse,
  ILoyaltyProductSimulateResponse,
  ILoyaltyWithdrawResponse,
  ILoyaltySendWithdrawResponse
} from './types';
import { Reducer } from 'redux';

const INITIAL_STATE: ILoyaltyState = {
  rewards: {
    loading: false,
    error: false,
    monthly_coins: [],
    total: {
      client_id: '',
      total_coins: 0,
      total_tonne: 0
    }
  },
  goal: {
    loading: false,
    error: false,
    monthly_goal: []
  },
  history: {
    loading: false,
    error: false,
    history_body: []
  },
  product: {
    loading: false,
    error: false,
    product_search: []
  },
  simulate: {
    loading: false,
    error: false,
    monthly_target: 0,
    simulation_tonne: 0,
    quarterly_target: 0
  },
  withdraw: {
    loading: false,
    error: false,
    status: 0,
    success: false,
    body: {
      campaign_card: 0,
      other_cards: 0,
      cards_limit: 0,
      activate_date: ''
    }
  },
  send_withdraw: {
    loading: false,
    error: false,
    status: 0,
    success: false,
    body: ''
  }
};

type TCustomAction = {
  type: Types;
  payload: {
    loyaltyRewardsResponse: ILoyaltyRewardsResponse;
    loyaltyGoalResponse: ILoyaltyGoalResponse;
    loyaltyHistoryResponse: ILoyaltyHistoryResponse;
    loyaltyProductResponse: ILoyaltyProductResponse;
    loyaltyProductSimulateResponse: ILoyaltyProductSimulateResponse;
    loyaltyWithdrawResponse: ILoyaltyWithdrawResponse;
    loyaltySendWithdrawResponse: ILoyaltySendWithdrawResponse;
  };
};

const reducer: Reducer<ILoyaltyState, TCustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.LOAD_LOYALTY_REWARDS:
      return {
        ...state,
        rewards: { ...state.rewards, loading: true, error: false }
      };
    case Types.LOAD_LOYALTY_REWARDS_SUCCESS:
      return {
        ...state,
        rewards: {
          ...state.rewards,
          ...action.payload.loyaltyRewardsResponse,
          loading: false,
          error: false
        }
      };
    case Types.LOAD_LOYALTY_REWARDS_FAILURE:
      return {
        ...state,
        rewards: { ...state.rewards, loading: false, error: true }
      };
    case Types.LOAD_LOYALTY_GOAL:
      return {
        ...state,
        goal: { ...state.goal, loading: true, error: false }
      };
    case Types.LOAD_LOYALTY_GOAL_SUCCESS:
      return {
        ...state,
        goal: {
          ...state.goal,
          ...action.payload.loyaltyGoalResponse,
          loading: false,
          error: false
        }
      };
    case Types.LOAD_LOYALTY_GOAL_FAILURE:
      return {
        ...state,
        goal: { ...state.goal, loading: false, error: true }
      };
    case Types.LOAD_LOYALTY_HISTORY:
      return {
        ...state,
        history: { ...state.history, loading: true, error: false }
      };
    case Types.LOAD_LOYALTY_HISTORY_SUCCESS:
      return {
        ...state,
        history: {
          ...state.history,
          ...action.payload.loyaltyHistoryResponse,
          loading: false,
          error: false
        }
      };
    case Types.LOAD_LOYALTY_HISTORY_FAILURE:
      return {
        ...state,
        history: { ...state.history, loading: false, error: true }
      };
    case Types.LOAD_LOYALTY_PRODUCT:
      return {
        ...state,
        product: { ...state.product, loading: true, error: false }
      };
    case Types.LOAD_LOYALTY_PRODUCT_SUCCESS:
      return {
        ...state,
        product: {
          ...state.product,
          ...action.payload.loyaltyProductResponse,
          loading: false,
          error: false
        }
      };
    case Types.LOAD_LOYALTY_PRODUCT_FAILURE:
      return {
        ...state,
        product: { ...state.product, loading: false, error: true }
      };
    case Types.LOAD_LOYALTY_PRODUCT_SIMULATE:
      return {
        ...state,
        simulate: { ...state.simulate, loading: true, error: false }
      };
    case Types.LOAD_LOYALTY_PRODUCT_SIMULATE_SUCCESS:
      return {
        ...state,
        simulate: {
          ...state.simulate,
          ...action.payload.loyaltyProductSimulateResponse,
          loading: false,
          error: false
        }
      };
    case Types.LOAD_LOYALTY_PRODUCT_SIMULATE_FAILURE:
      return {
        ...state,
        simulate: { ...state.simulate, loading: false, error: true }
      };

    case Types.LOAD_LOYALTY_WITHDRAW:
      return {
        ...state,
        withdraw: { ...state.withdraw, loading: true, error: false }
      };
    case Types.LOAD_LOYALTY_WITHDRAW_SUCCESS:
      return {
        ...state,
        withdraw: {
          ...state.withdraw,
          ...action.payload.loyaltyWithdrawResponse,
          loading: false,
          error: false
        }
      };
    case Types.LOAD_LOYALTY_WITHDRAW_FAILURE:
      return {
        ...state,
        withdraw: { ...state.withdraw, loading: false, error: true }
      };
    case Types.LOAD_LOYALTY_SEND_WITHDRAW:
      return {
        ...state,
        send_withdraw: { ...state.send_withdraw, loading: true, error: false }
      };
    case Types.LOAD_LOYALTY_SEND_WITHDRAW_SUCCESS:
      return {
        ...state,
        send_withdraw: {
          ...state.send_withdraw,
          ...action.payload.loyaltySendWithdrawResponse,
          loading: false,
          error: false
        }
      };
    case Types.LOAD_LOYALTY_SEND_WITHDRAW_FAILURE:
      return {
        ...state,
        send_withdraw: { ...state.send_withdraw, loading: false, error: true }
      };

    default:
      return state;
  }
};

export default reducer;
